import { AxiosError } from 'axios';

export const accept4xx = (status: number): boolean => status >= 200 && status < 500;

export const accept20x = (status: number): boolean => /20[0-9]/.test(String(status));

export const accept5xx = (status: number): boolean => /5[0-9][0-9]/.test(String(status));

export const isNetWorkError = (error: AxiosError): boolean => !!error.isAxiosError && !error.response;
